// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/wing-blank/style/index.less
// module id = 235
// module chunks = 0